<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  modelValue: number
  min?: number
  max?: number
  step?: number
  label?: string
}>()

defineEmits<{
  'update:modelValue': [value: number]
}>()

const trackStyle = computed(() => {
  const min = props.min ?? 0
  const max = props.max ?? 100
  const percent = ((props.modelValue - min) / (max - min)) * 100
  return {
    background: `linear-gradient(to right, #3b82f6 ${percent}%, #515b69 ${percent}%)`,
  }
})
</script>

<template>
  <div>
    <label v-if="label" class="block mb-2 text-subtext">{{ label }}</label>
    <input
      type="range"
      :value="modelValue"
      :min="min ?? 0"
      :max="max ?? 100"
      :step="step ?? 1"
      :style="trackStyle"
      class="w-full h-1.5 rounded-lg appearance-none cursor-pointer accent-blue-500"
      @input="$emit('update:modelValue', Number(($event.target as HTMLInputElement).value))"
    />
  </div>
</template>
